export default {
      id: "icon-angle-thin-down-usage",
      viewBox: "0 0 20 20",
      url: __webpack_public_path__ + "icons.svg#icon-angle-thin-down",
      toString: function () {
        return this.url;
      }
    }